import { render, staticRenderFns } from "./Pickls.vue?vue&type=template&id=2353060b&scoped=true&"
import script from "./Pickls.vue?vue&type=script&lang=ts&"
export * from "./Pickls.vue?vue&type=script&lang=ts&"
import style0 from "./Pickls.vue?vue&type=style&index=0&id=2353060b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353060b",
  null
  
)

export default component.exports